export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer nicht gefunden"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswählen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schließen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
}